import React, { Component } from "react";
import Store from "../../content/Store";
import Tooltip from "../shared/Tooltip";
import ToggleDrawer from "../shared/containers/ToggleDrawer";
import style from "../../assets/css/modules/cover/cover-benefit-row.css";
import Media from "react-media";
import { Breakpoints } from "../../constants/CssConstants";
import TooltipIcon from "../shared/form/TooltipIcon";
import Content from "../../content/Content";

const individualAmountColumnHeadingStyle = "hidden-lg-up col-4";
const individualAmountColumnStyle = "col-lg-2 col-4";

export class CoverBenefitRow extends Component {
  constructor(props) {
    super(props);
    this.state = { toolTipVisible: [] };
  }

  toggleTooltip = (index) => {
    const arr = this.state.toolTipVisible.slice();
    arr[index] = !arr[index];
    this.setState({
      toolTipVisible: arr
    });
  };

  render() {
    const amountsSection = (
      <React.Fragment>
        {!this.props.mergedColumnsDescription && (
          <React.Fragment>
            <div
              className={`${individualAmountColumnHeadingStyle} ${style.header}`}
            >
              Limits
            </div>
            <div
              className={`${individualAmountColumnHeadingStyle} ${style.header}`}
            >
              Used
            </div>
            <div
              className={`${individualAmountColumnHeadingStyle} ${style.header}`}
            >
              Remaining
            </div>
          </React.Fragment>
        )}
        {this.props.mergedColumnsDescription ? (
          <React.Fragment>
            <div className={"col-lg-6 " + style.detail}>
              <Content name={this.props.mergedColumnsDescription} />
            </div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <div
              className={`${individualAmountColumnStyle} ${
                this.props.isHeader ? style.header : style.detail
              }`}
            >
              {this.props.subBenefit.Limits}
            </div>
            <div
              className={`${individualAmountColumnStyle} ${
                this.props.isHeader ? style.header : style.detail
              }`}
            >
              {this.props.subBenefit.Used}
            </div>
            <div
              className={`${individualAmountColumnStyle} ${
                this.props.isHeader ? style.header : style.detail
              }`}
            >
              {this.props.subBenefit.Remaining}
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    );
    return (
      <div
        className={"row no-gutters " + style.row}
        id={"subBenefitKey" + this.props.rowId}
      >
        {this.props.subBenefit.Description.map((desc, index) => {
          return (
            <React.Fragment key={index}>
              <div
                className={
                  "col-lg-6 " +
                  style.subBenefitRow +
                  (index === 0 ? " " + style.subBenefitRowFirst : "") +
                  (index === this.props.subBenefit.Description.length - 1
                    ? " " + style.subBenefitRowLast
                    : "")
                }
              >
                <div
                  className={
                    "subBenefitDescription " +
                    style.subBenefitDescription +
                    " " +
                    (this.props.isHeader ? style.header : "")
                  }
                >
                  {desc.Name}
                  {desc.Type && Store.CoverTooltip[desc.Type] ? (
                    <TooltipIcon
                      customStyle={style.tooltipIcon}
                      onToggle={() => this.toggleTooltip(index)}
                      ariaLabel={"Further information on " + desc.Name}
                    />
                  ) : null}
                </div>
              </div>
              <Media query={Breakpoints.lgUp}>
                {(matches) => (matches && index === 0 ? amountsSection : null)}
              </Media>
              {desc.Type && Store.CoverTooltip[desc.Type] ? (
                <div className="col-12 ">
                  <ToggleDrawer
                    isOpen={this.state.toolTipVisible[index]}
                    gradientClass="primary"
                    bottom
                  >
                    <Tooltip
                      text={Store.CoverTooltip[desc.Type]}
                      customStyle={style.tooltip}
                    />
                  </ToggleDrawer>
                </div>
              ) : null}
            </React.Fragment>
          );
        })}
        <Media query={Breakpoints.mdDown}>
          {(matches) =>
            matches ? (
              <React.Fragment>
                <div className={"col-12 " + style.bottomAmountSection} />
                {amountsSection}
              </React.Fragment>
            ) : null
          }
        </Media>
      </div>
    );
  }
}
